/**
 * JeriCommerce Pass API · staging
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 202609.19.01
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProgramEngagementFlowResponseDto } from './program-engagement-flow-response-dto';


export interface EngagementFlowWithProgramEngagementFlowDto { 
    id: string;
    name: EngagementFlowWithProgramEngagementFlowDto.NameEnum;
    active: boolean;
    createdAt: string;
    updatedAt: string;
    programEngagementFlows: Array<ProgramEngagementFlowResponseDto>;
}
export namespace EngagementFlowWithProgramEngagementFlowDto {
    export type NameEnum = 'COMPLETE_USER_PROFILE' | 'CUSTOM_1' | 'CUSTOM_2' | 'CUSTOM_3' | 'CUSTOM_4' | 'CUSTOM_5' | 'CUSTOMER_SCANNED' | 'FOLLOW_US' | 'INCENTIVIZE_PURCHASES' | 'INSTALL_WALLET_PASS' | 'MEMBER_GET_MEMBER' | 'VERIFY_ACCOUNT' | 'WALLET_LINK_CLICK';
    export const NameEnum = {
        CompleteUserProfile: 'COMPLETE_USER_PROFILE' as NameEnum,
        Custom1: 'CUSTOM_1' as NameEnum,
        Custom2: 'CUSTOM_2' as NameEnum,
        Custom3: 'CUSTOM_3' as NameEnum,
        Custom4: 'CUSTOM_4' as NameEnum,
        Custom5: 'CUSTOM_5' as NameEnum,
        CustomerScanned: 'CUSTOMER_SCANNED' as NameEnum,
        FollowUs: 'FOLLOW_US' as NameEnum,
        IncentivizePurchases: 'INCENTIVIZE_PURCHASES' as NameEnum,
        InstallWalletPass: 'INSTALL_WALLET_PASS' as NameEnum,
        MemberGetMember: 'MEMBER_GET_MEMBER' as NameEnum,
        VerifyAccount: 'VERIFY_ACCOUNT' as NameEnum,
        WalletLinkClick: 'WALLET_LINK_CLICK' as NameEnum
    };
}


